import Pill, { SIZES } from './Pill';

export default Pill;
export { SIZES };
